import { useQuery } from "@tanstack/react-query";
import fetchToBackend, { buildQuery } from "@/utils/fetchToBackend";
import { contractingTaskKeys } from "@/lib/query-keys";
import type { ContractingTask } from "@/types/domain";

export interface TaskFilters {
  contractingId?: number;
  /** "mine" acota a las del propio usuario; sin esto, las de todo el equipo. */
  scope?: "mine";
  includeDone?: boolean;
}

/** Las tareas del equipo, las que vencen antes primero. */
export function useContractingTasks(filters: TaskFilters = {}, enabled = true) {
  return useQuery({
    queryKey: contractingTaskKeys.list(filters),
    enabled,
    queryFn: () =>
      fetchToBackend<ContractingTask[]>(
        `/contractingtasks${buildQuery({
          contractingId: filters.contractingId,
          scope: filters.scope,
          includeDone: filters.includeDone ? "true" : undefined,
        })}`,
      ),
  });
}
